module.exports = __webpack_public_path__ + "img/179983.38bbf0a0.png";